import React, { useEffect } from "react";
import { createContext, ReactNode, useContext, useState } from "react";
import { Data, CartEntity } from "../../models/checkoutData";
import {
  createCheckout,
  createOrder,
  fetchCheckout,
} from "../../services/checkout/checkout";
import {
  RazorOrder,
  RazorData,
  ShopifyOrderData,
  Status,
} from "../../models/razorData";
import { useShoppingCart } from "../CartContext.tsx/ShoppingCartContext";
import { Console } from "console";
import { Navigate } from "react-router-dom";

interface checkoutProps {
  data: Data;
}

interface razorProps {
  razorData: RazorData;
}

interface shopifyOrderProps {
  ShopifyOrder: ShopifyOrderData;
}

interface orderStatusProps {
  Status: Status;
}

interface checkoutStatusProps {
  checkoutOpen: boolean | any;
}

type checkoutProviderProps = {
  children: ReactNode;
};

type checkoutContext = {
  createCart: (id: number) => void;
  createRazorOrder: (id: any) => void;
  getOrderStatus: (id: number) => void;
  createShopifyOrder: (payload: any) => void;
  setRazorDataFunction: () => void;
  setOrderStatusFunction: () => void;
  setIsShopifyOrderFunction: () => void;
  setStatusFlagFunction: () => void;
  // checkoutData: (data:Data) =>void
  checkoutData: checkoutProps | null | undefined;
  razorOrderData: razorProps | null | undefined;
  orderStatus: orderStatusProps | null | undefined;
  shopifyOrderData: shopifyOrderProps | null | undefined;
  // checkoutStatus : boolean | any
  getCheckoutError: any;
  setCheckoutError: (payload: any) => void;
  isShopifyOrderData: any;
  statusFlagData: any;
};

type CartItem = {
  id: number;
  quantity: number;
};

const CheckoutContext = createContext<checkoutContext>({
  createCart: () => {},
  createRazorOrder: () => {},
  getOrderStatus: () => {},
  createShopifyOrder: () => {},
  checkoutData: null,
  razorOrderData: null,
  orderStatus: null,
  shopifyOrderData: null,
  setRazorDataFunction: () => {},
  setOrderStatusFunction: () => {},
  setIsShopifyOrderFunction: () => {},
  setStatusFlagFunction: () => {},
  getCheckoutError: null,
  setCheckoutError: () => {},
  // checkoutStatus : false
  // checkoutData: () => {}
  isShopifyOrderData: null,
  statusFlagData: null,
});

export function useCheckoutContext() {
  return useContext(CheckoutContext);
}

export function CheckoutProvider({ children }: checkoutProviderProps) {
  const [data, setCheckout] = useState<checkoutProps | null>();
  const [razorData, setRazorData] = useState<razorProps | null>();
  const [status, setStatus] = useState<orderStatusProps | null>();
  const [ShopifyOrder, setShopifyOrder] = useState<shopifyOrderProps | null>();
  // const [checkoutOpen, setCheckoutOpen] = useState(false);
  const { tokenData, setLoader, closePopup, setPageData } = useShoppingCart();

  const [isCheckoutError, setIsCheckoutError] = useState("");

  function setCheckoutError() {
    setIsCheckoutError("");
  }

  function createCart(paylaod: any) {
    // console.log(paylaod,'ytyutytu');
    // setLoader('loading')
    setIsCheckoutError("");
    fetchCheckout("app/api/v1/checkout/cart/create", paylaod)
      .then((response: Data) => {
        if (response && response.cart?.length && response.cart?.length > 0) {
          setCheckout({ data: response });
          setIsCheckoutError("success");

          // setLoader('success')
        } else {
          // console.log(response.response.data.message.message);
          // let error = response.response.data.message.message;
          let error = "Something went wrong! Please Try Again!";
          setIsCheckoutError(error);
          closePopup();
          setPageData(1);

          return;
        }
      })
      .catch((error: any) => console.log(error));
  }

  function createRazorOrder(id: any) {
    createCheckout("app/api/v1/checkout/razor/order/create", id)
      .then((response: RazorData | any) => {
        if (response) {
          // console.log(response);
          setRazorData({ razorData: response });
        } else {
        }
      })
      .catch((error: any) => console.log(error));
  }

  // post api
  function createShopifyOrder(payload: any) {

    createOrder("app/api/v1/checkout/shopify/order/create", payload)
      .then((response: shopifyOrderProps | any) => {
        if (response) {
          setShopifyOrder({ ShopifyOrder: response });
          getOrderStatus(response.order.id);
        } else {
          // let error1 = "Something went wrong! Please Try Again!";
          //     setIsCheckoutError(error1);
          //     closePopup();
          //     setPageData(1);
          //     setOrderStatusFunction();
          //     setRazorDataFunction();
          //     return;
        }
      })
      .catch((error: any) => {
        console.log(error);
        let error1 = "Something went wrong! Please Try Again!";
        setIsCheckoutError(error1);
        closePopup();
        setPageData(1);
        return;
      });
  }
  
  let flagStatus: number = 1;

  function getOrderStatus(id: number) {

    createCheckout("app/v1/checkout/order/status", id)
      .then((response: orderStatusProps | any) => {
        if (response) {
          // console.log(response);
            if (
              response.lenskart_order_id === null &&               
              response.status !== "CANCELLED" && flagStatus <= 30
              ) {
          
                 getOrderStatus(id);
                 flagStatus = flagStatus + 1;
                //  console.log(flagStatus);
              }else{
                setStatus({ Status: response });
              }

        }
      })
      .catch((error: any) => console.log(error));
  }

  function setRazorDataFunction() {
    setRazorData(null);
  }

  function setOrderStatusFunction() {
    setStatus(null);
  }

  const [isShopifyOrder, setIsShopifyOrder] = useState(false); // loader flag cod
  function setIsShopifyOrderFunction() {
    setIsShopifyOrder(false);
  }

  const [statusFlag, setStatusFlag] = useState(1); 
  function setStatusFlagFunction() {
    setStatusFlag(statusFlag + 1);
  }

  return (
    <CheckoutContext.Provider
      value={{
        checkoutData: data,
        createCart,
        createRazorOrder,
        razorOrderData: razorData,
        getOrderStatus,
        orderStatus: status,
        createShopifyOrder,
        shopifyOrderData: ShopifyOrder,
        setRazorDataFunction,
        setOrderStatusFunction,
        getCheckoutError: isCheckoutError,
        setCheckoutError,
        setIsShopifyOrderFunction,
        isShopifyOrderData: isShopifyOrder,
        setStatusFlagFunction,
        statusFlagData: statusFlag,

        // checkoutStatus : checkoutOpen
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
}
